import { create } from 'zustand';

const usePaginationStore = create((set, get) => ({
    currentPage: 1,
    limitFilter: 10,
    totalItems: 0,
    paginationLoading: false,
    PaginationNavBarQuery: '',

    setPage: (page) => {
        const { totalItems, limitFilter } = get();
        const totalPages = Math.ceil(totalItems / limitFilter);
        const newPage = page > totalPages ? totalPages : page;
        set({ currentPage: newPage });
    },

    setLimitFilter: (limit) => {
        set({ limitFilter: limit });
        const { totalItems, currentPage } = get();
        const totalPages = Math.ceil(totalItems / limit);
        if (currentPage > totalPages) {
            set({ currentPage: totalPages });
        }
    },

    setTotalItems: (total) => {
        set({ totalItems: total });
        const { limitFilter, currentPage } = get();
        const totalPages = Math.ceil(total / limitFilter);
        if (currentPage > totalPages) {
            set({ currentPage: totalPages });
        }
    },

    setPaginationLoading: (loading) => set({ paginationLoading: loading }),

    setPaginationNavBarQuery: (query) => set({ PaginationNavBarQuery: query }),

    resetPagination: () => set({ currentPage: 1, /* limitFilter: 10, */ totalItems: 0, paginationLoading: false, PaginationNavBarQuery: '' }),
}));

const resetPaginationOnBack = () => {
    const resetPagination = usePaginationStore.getState().resetPagination;
    window.onpopstate = () => {
        resetPagination();
    };
};

resetPaginationOnBack();

export default usePaginationStore;